import { styled } from '@mui/material';
import Check from 'images/check.svg';
import { SelectInput as GlobalSelectInput } from 'shared-components/Select';

export const SelectInput = styled(GlobalSelectInput)({
  '&.Mui-focused' : {
    boxShadow   : '0 0 0 1px #00778B',
    borderColor : 'rgba(0, 0, 0, 0)',
  },
});

export const menuProps = {
  sx : {
    '& .MuiMenu-list' : {
      background : (theme) => theme.palette.primary.white,
      '& li'     : {
        padding    : '15px 64px 15px 20px',
        color      : (theme) => theme.palette.primary.gray75,
        fontFamily : 'Montserrat',
        fontWeight : 700,
        fontSize   : '14px',
        fontStyle  : 'normal',
        lineHeight : '17px',
        opacity    : 0.8,
        whiteSpace : 'unset',
        wordBreak  : 'break-word',
      },
      '& li:hover' : {
        '&:not(li.Mui-selected)' : {
          background : (theme) => theme.palette.primary.white,
          color      : (theme) => theme.palette.primary.gray100,
          opacity    : 0.8,
        },
      },
      '& li.Mui-selected' : {
        background         : (theme) => theme.palette.primary.gray2,
        color              : '#00778B',
        opacity            : 1,
        backgroundImage    : `url(${Check})`,
        backgroundRepeat   : 'no-repeat',
        backgroundPosition : 'right 21px center',
      },
    },
  },
};
